/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 操作レベル
 */
export interface GetOrderResponseDataOrderEligibilitiesEligibilityLevel {
  /**
   * 操作レベル<br/> 1：予約操作不可(restrictedReasonsの予約操作不可理由のいずれかに合致する場合)<br/> 2：旅程操作不可(restrictedReasonsの旅程操作不可理由のいずれかに合致する場合)<br/> 3：制限なし(restrictedReasonが存在しない)
   */
  level?: GetOrderResponseDataOrderEligibilitiesEligibilityLevel.LevelEnum;
  /**
   * 不可理由<br/> [予約操作不可理由]<br/> callCenterHandlingSegment：旅程にセグメントステータスが要確認ステータスのセグメントを含む<br/> ※要確認ステータスは設定ファイルに定義<br/> ignoreSegment：フリーテキストに\"WEB//@IGNORE\"を含むRMエレメントが存在する<br/> failedFareRecalculatetion：DxAPIから運賃の再計算ができない旨のエラーが返却された<br/> pnrUnmodifiablePtc：ASWで定めるPNR更新不可旅客種別(設定ファイルに定義)のみのPNR<br/> dupeSegment：旅程内に、便名、出発日、suffix識別が重複し、セグメントステータスが両方とも確定済み(設定ファイルに定義)となるセグメントが存在する<br/> ※suffix識別がない場合は「suffix識別なし」として重複かどうかを判定する<br/> cabinBaggageOrExtraSeat：コードがCBBG/EXSTであるSSRエレメントが存在する<br/> [旅程操作不可理由]<br/> gdsBooking：GDS PNRである<br/> unknownOfflineOffice：NH作成のコールセンターPNRだが、PNRオーナーオフィスIDがオフラインオフィステーブルに存在せず、操作オフィスの特定ができない<br/> paymentAccepted：購入・発券状態が支払受付中<br/> unticketed：購入・発券状態が未発券<br/> staffBooking：社員用PNR区分がtrue<br/> currencyDiscrepancy：PNRチャネル区分がGDS PNRで、航空券の通貨とオフィスの通貨が異なる<br/> invalidSegment：以下のいずれかに該当するセグメントが存在する<br/> 1.ステータスがパッシブセグメント(設定ファイルに定義)<br/> 2.ステータスがゴーストセグメント(設定ファイルに定義)<br/> 3.OPEN便<br/> 4.Informative Segment<br/> ※Informative Segmentの判定は、DxAPIが返却するインジケータにて行う想定。現在GAP開発中<br/> taxExemption：DxAPIより返却される搭乗者種別毎の税金情報に、免除する旨の情報が含まれている<br/> inhibitFare：Fare Basisの2文字目以降に運賃対象外FareBasis(設定ファイルに定義)が含まれる<br/> groupBooking：グループPNR domesticAgencyBooking：国内代理店作成PNR
   */
  restrictedReasons?: Array<GetOrderResponseDataOrderEligibilitiesEligibilityLevel.RestrictedReasonsEnum>;
}
export namespace GetOrderResponseDataOrderEligibilitiesEligibilityLevel {
  export type LevelEnum = '1' | '2' | '3';
  export const LevelEnum = {
    _1: '1' as LevelEnum,
    _2: '2' as LevelEnum,
    _3: '3' as LevelEnum,
  };
  export type RestrictedReasonsEnum =
    | 'callCenterHandlingSegment'
    | 'ignoreSegment'
    | 'failedFareRecalculatetion'
    | 'pnrUnmodifiablePtc'
    | 'dupeSegment'
    | 'cabinBaggageOrExtraSeat'
    | 'gdsBooking'
    | 'unknownOfflineOffice'
    | 'paymentAccepted'
    | 'unticketed'
    | 'staffBooking'
    | 'currencyDiscrepancy'
    | 'invalidSegment'
    | 'taxExemption'
    | 'inhibitFare'
    | 'groupBooking'
    | 'domesticAgencyBooking';
  export const RestrictedReasonsEnum = {
    CallCenterHandlingSegment: 'callCenterHandlingSegment' as RestrictedReasonsEnum,
    IgnoreSegment: 'ignoreSegment' as RestrictedReasonsEnum,
    FailedFareRecalculatetion: 'failedFareRecalculatetion' as RestrictedReasonsEnum,
    PnrUnmodifiablePtc: 'pnrUnmodifiablePtc' as RestrictedReasonsEnum,
    DupeSegment: 'dupeSegment' as RestrictedReasonsEnum,
    CabinBaggageOrExtraSeat: 'cabinBaggageOrExtraSeat' as RestrictedReasonsEnum,
    GdsBooking: 'gdsBooking' as RestrictedReasonsEnum,
    UnknownOfflineOffice: 'unknownOfflineOffice' as RestrictedReasonsEnum,
    PaymentAccepted: 'paymentAccepted' as RestrictedReasonsEnum,
    Unticketed: 'unticketed' as RestrictedReasonsEnum,
    StaffBooking: 'staffBooking' as RestrictedReasonsEnum,
    CurrencyDiscrepancy: 'currencyDiscrepancy' as RestrictedReasonsEnum,
    InvalidSegment: 'invalidSegment' as RestrictedReasonsEnum,
    TaxExemption: 'taxExemption' as RestrictedReasonsEnum,
    InhibitFare: 'inhibitFare' as RestrictedReasonsEnum,
    GroupBooking: 'groupBooking' as RestrictedReasonsEnum,
    DomesticAgencyBooking: 'domesticAgencyBooking' as RestrictedReasonsEnum,
  };
}
